import styled from 'styled-components';
import {Palette} from 'hubbl-shared';
import {TextHeading3} from '../text/TextHeading3';
import {TextBodyMedium} from '../text/TextBodyMedium';

interface EnvironmentDownScreenProps {
  title: string;
  description: string;
}

export const EnvironmentDownScreen = ({
  title,
  description,
}: EnvironmentDownScreenProps) => {
  return (
    <Container>
      <Content>
        <TextHeading3 text={title} style={{textAlign: 'center'}} />
        <TextBodyMedium
          text={description}
          color={Palette.almostBlack750}
          style={{textAlign: 'center', marginTop: 12}}
        />
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background-color: ${Palette.white};
  padding: 24px;
  box-sizing: border-box;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
`;
